import React, { Component } from "react";
import "./Site.css";
import "react-datepicker/dist/react-datepicker.css";
import { Chart, Line } from "react-chartjs-2";
import _ from "lodash";
import chartTrendline from "chartjs-plugin-trendline";

const formatMultiLineData = (
  xAxisLabels,
  dataList,
  labels,
  borderColors,
  hoverBorderColors
) => {
  var multiLineData = _.map(dataList, (d, index) => {
    var data = {
      data: d,
      label: _.find(labels, (l, idx) => {
        return idx === index;
      }),
      borderColor: _.find(borderColors, (bc, idx) => {
        return idx === index;
      }),
      hoverBorderColor: _.find(hoverBorderColors, (h, idx) => {
        return idx === index;
      })
    };
    return data;
  });
  var shapedData = {
    labels: xAxisLabels,
    datasets: multiLineData
  };
  return shapedData;
};

const formatData = (
  xAxisLabels,
  data,
  label,
  borderColor,
  hoverBorderColor,
  addTrendLine
) => {
  let datasetOptions = {
    label: label,
    borderColor: borderColor,
    borderWidth: 1,
    hoverBackgroundColor: "#1C8033",
    hoverBorderColor: hoverBorderColor,
    data: data
  };
  //console.log(datasetOptions, "DATA SET OPTIONS")
  if (addTrendLine) {
    datasetOptions = {
      ...datasetOptions,
      trendlineLinear: {
        style: "rgba(255,105,180, .8)",
        lineStyle: "dotted|solid",
        width: 2
      }
    };
  }
  var shapedData = {
    labels: xAxisLabels,
    datasets: [datasetOptions]
  };
  return shapedData;
};

export default class LineGraph extends Component {
  static displayName = LineGraph.name;
  constructor(props) {
    super(props);
    this.state = {
      data: props.isMultiLine
        ? formatMultiLineData(
            props.xAxisLabels,
            props.data,
            props.label,
            props.borderColor,
            props.hoverBorderColor
          )
        : formatData(
            props.xAxisLabels,
            props.data,
            props.label,
            props.borderColor,
            props.hoverBorderColor,
            props.addTrendLine || false
          )
    };
  }

  componentWillMount() {
  //console.log(this.props)
    Chart.plugins.register(chartTrendline);
  }

  render() {
    //console.log(this.props, this.state.data, "hereherhr")

    return (
      <div>
        <Line
          data={this.state.data}
          width={200}
          height={200}
          options={{
            responsive: true,
            maintainAspectRatio: false,
            layout: {
              padding: {
                left: 50,
                right: 0,
                top: 0,
                bottom: 0
              }
            },
            title: {
              display: this.props.display,
              text: this.props.text
            }
          }}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/LineGraph.js